import React, {useState} from 'react';
import classnames from 'classnames';
import {Modal, removeHtml} from "@nutastic/nutastic-react-app";
import Fade from 'react-reveal/Fade';

const BookSessionModal = ({ isOpen, onClose, packageTypes, selectedType }) => {
    const [ modalStage, setModalStage ] = useState(1);
    const componentClass = "bookingModal";
    const modalCloseBtn = <div className="btn btn-outline-secondary">Close</div>;

    const onCloseClick = () => {
        setModalStage(1);
        onClose();
    }

    const renderReturningClientButton = () => {
        if(selectedType) {
            const { field_1: url, title } = selectedType;
            return <a className={`${componentClass}__button`} href={url} target="_blank">
                <h1>Returning Client</h1>
                <p>Click here if you are ready to schedule a session for: <b>{ title }</b></p>
            </a>
        } else {
            return <div className={`${componentClass}__button`} onClick={() => setModalStage(2)}>
                <h1>Returning Client</h1>
                <p>Click here if you are ready to schedule a session for one of the listed services.</p>
            </div>
        }
    }

    const clientSelectStep = <div className={`${componentClass}__clientType`}>
        <a className={`${componentClass}__button`} href="https://unmaskpurposebiblicalcounselingandcoaching.hbportal.co/schedule/62be4e6e23b342002aec5fc0" target="_blank">
            <h1>New Client</h1>
            <p>Select this to schedule your free consultation. We will get to know each other and we will review the services to find the right fit for us to build on.</p>
        </a>
        { renderReturningClientButton() }
    </div>;

    const returningClientStep = <div className={`${componentClass}__selectOption`}>
        {
            (packageTypes || []).map((pkg, i) => {
                const { field_1: url, title, content: info } = pkg;
                return <a className={`${componentClass}__button`} href={url} target="_blank" key={i}>
                    <h1>{ title }</h1>
                    <p>{ info }</p>
                </a>
            })
        }
    </div>;

    return <Modal className={componentClass} closeBtn={modalCloseBtn} onClose={onCloseClick} show={isOpen} title="Schedule a Session">
        { modalStage !== 1 && <div className={`${componentClass}__resetBtn`} onClick={() => setModalStage(1)}>Go Back</div> }
        <span className={`${componentClass}__helpText`}>Select an option to schedule a session:</span>
        { modalStage === 1 ? clientSelectStep : returningClientStep }
    </Modal>
};

export default BookSessionModal;
